<template>
    <div class="examEntrance"
        :style="{ 'width': _isMobile() ? '100%' : '1200px', 'margin': _isMobile() ? '-28px auto' : '0 auto' }">
        <div class="mainContent" :style="{ borderRadius: _isMobile() ? '28px 28px 0 0' : 'none' }">
            <img src="../../assets/image/JXW.png" class="jxwLogo" alt="">
            <div class="maxButton" v-if="queryInfo">
                <h1>{{ queryInfo.paperName }}</h1>
                <p>考试时间：【{{queryInfo.timeLimit}}】分钟</p>
                <p>可作答【{{ queryInfo.submitTimesLimit }}】次</p>
            </div>
            <div class="minButton" @click="toPageFn(queryInfo)">
                进入考试 <i class="iconfont" style="font-size: 12px;">&#xe626;</i>
            </div>
        </div>
    </div>
</template>

<script>
import { mixinDevice } from "@/utils/mixin.js";
import { getAction } from '@/api/manage'
export default {
    name: 'examEntrance',
    components: {},
    mixins: [mixinDevice],
    data() {
        return {
            queryInfo: {},
        }
    },
    created() {
        this.queryInfo = this.$route.query;
    },
    mounted() { },
    methods: {
        toPageFn(row) {
            let _this = this
            _this.$router.push({
                path: '/examination/index', query: {
                    paperDeptId: row.paperDeptId,
                    paperId: row.paperId,
                    departId: row.departId,
                }
            });
        }
    }
}
</script>

<style lang='scss' scoped>
.examEntrance {
    width: 100%;
    margin: -28px auto;

    .chapterList {
        margin: 5px auto;
        width: 90%;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: rgba(244, 244, 244, 0.863);
        border: 0px solid;
        border-image: linear-gradient(0deg, #000000, #FFFFFF) 10 10;
        box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.08);
        color: #6E6D6D;
        font-size: 18px;
        border-radius: 5px;
        padding: 0 16px;
        cursor: pointer;
    }

    .chapterList:hover {
        background: #F75250;
        color: #fff;
    }

    .mainContent {
        width: 100%;
        background: #fff;
        position: relative;
        padding: 64px 0;

        .jxwLogo {
            width: 67px;
            height: 70px;
            position: absolute;
            top: -31px;
            right: 13px;
            z-index: 9;
        }

        .maxButton {
            width: 237px;
            height: 237px;
            background: linear-gradient(180deg, #F15051 24%, #FCB8B7 100%);
            border-radius: 50%;
            margin: 0 auto;
            box-shadow: 0 0 10px #FCB8B7;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;

            h1 {
                font-weight: bold;
                font-size: 23px;
                color: #fff;
                margin: 0;
                margin-top:30px ;
            }

            p {
                font-size: 12px;
                color: #fff;
                line-height: 25px;
                font-weight: bold;
            }
        }

        .minButton {
            width: 120px;
            height: 38px;
            background: #f87c7898;
            box-shadow: 1px 2px 7px 0px rgba(0, 0, 0, 0.34);
            text-align: center;
            line-height: 38px;
            font-size: 13px;
            color: #fff;
            cursor: pointer;
            margin: 50px auto;
            border-radius: 5px;
        }

    }

}
</style>